<template>
  <div
    class="pills pills--hidden"
    :class="classes"
  >
    <div
      v-for="column in columns"
      :key="column"
      class="pill-col"
    >
      <Pill
        v-for="row in randomRow()"
        :key="row"
        random
        :density="density"
        :overflow="overflowAtColumn !== 0 && column >= overflowAtColumn"
        :randomAnimationDelay="randomAnimationDelay"
        ref="pills"
      />
    </div>
  </div>
</template>

<script>
import { randomIntBetween } from '@/utilities/random';
import Pill from '@/components/pills/Pill.vue';

export default {
  name: 'PillsRandom',
  components: { Pill },
  props: {
    columns: Number,
    density: {
      type: Number,
      default: 100
    },
    hero: {
      type: Boolean,
      default: false
    },
    context: {
      type: String,
      default: ''
    },
    overflowAtColumn: {
      type: Number,
      default: 0
    },
    animated: {
      type: Boolean,
      default: false
    },
    randomAnimationDelay: {
      type: Boolean,
      default: true
    }
  },
  async mounted () {
    await this.$nextTick();
    if (this.hero) {
      this.hidePillsBehindHeroText();
      window.addEventListener('resize', this.hidePillsBehindHeroText);
    }

    this.$el.classList.add('pills--away');
    setTimeout(() => {
      this.$el.classList.remove('pills--hidden');
      this.$el.classList.add('pills--drop');
      this.$el.classList.remove('pills--away');
    }, 0);
  },
  unmounted () {
    if (this.hero) {
      window.removeEventListener('resize', this.hidePillsBehindHeroText);
    }
  },
  computed: {
    classes () {
      return {
        'pills-animated': this.animated || this.hero
      };
    }
  },
  methods: {
    randomIntBetween,
    randomRow () {
      return (
        Math.floor(
          (this.density / 100) *
          randomIntBetween(2, 8)
        )
      );
    },
    hidePillsBehindHeroText () {
      const heroParts = Array.from(document.querySelectorAll('.hero-part'));

      if (heroParts.length === 0) return;

      const hero = document.querySelector('.hero');
      const heroPartBuffer = 50;
      const forDoctorsBuffer = 70;
      const leadershipBuffer = 80;

      this.$refs.pills.forEach((pill) => {
        const {
          top,
          right,
          bottom,
          left
        } = pill.$el.getBoundingClientRect();

        let pillIsHidden = false;

        heroParts.forEach((heroPart) => {
          const {
            top: textTop,
            bottom: textBottom,
            left: textLeft,
            right: textRight
          } = heroPart.getBoundingClientRect();

          if (
            (
              left < textRight + heroPartBuffer &&
              right > textLeft - heroPartBuffer &&
              top < textBottom + heroPartBuffer &&
              bottom > textTop - heroPartBuffer
            ) || (
              this.context === 'for-doctors' &&
              top < (
                hero.getBoundingClientRect().top +
                (hero.getBoundingClientRect().height / 2) +
                forDoctorsBuffer
              )
            ) || (
              this.context === 'leadership' &&
              top < (
                hero.getBoundingClientRect().top +
                leadershipBuffer
              )
            )
          ) {
            pillIsHidden = true;
          }
        });

        pill.$el.setAttribute('data-invisible', pillIsHidden);
      });
    }
  }
};
</script>>
